export const getLabelsWithKrn = (state: any): any => state.labelsWithKrn;
